import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let HousecallIcon = (props) => (
        <SvgIcon {...props}>
            <g>
                <polygon points="16.719,2.917 15.813,2.917 15.813,5.216 16.719,5.216 16.719,19.12 15.813,19.12 15.813,21.418 16.719,21.418
		19.165,21.418 19.165,2.917 	"/>
                <polygon points="7.281,19.12 7.281,5.216 7.281,4.623 9.87,2.917 7.281,2.917 4.835,2.917 4.835,21.418 7.281,21.418
		10.395,21.418 7.281,19.363 	"/>
                <polygon points="8.057,5.041 8.057,5.216 8.057,18.945 8.323,19.12 11.803,21.418 15.037,23.558 15.037,21.418 15.037,19.12
		15.037,5.216 15.037,2.917 15.037,0.443 11.281,2.917 	"/>
            </g>
        </SvgIcon>
);

HousecallIcon = pure(HousecallIcon);
HousecallIcon.displayName = 'Housecall icon';
HousecallIcon.muiName = 'SvgIcon';

export default HousecallIcon;